import alert from '../../components/alerts.js'

const stripe = Stripe(window.stripeKey);

/**
 * Handles successful createToken call.
 */
function tokenSuccessHandler(token) {
  const form = document.getElementById('add-card-form')
  const hiddenInput = document.createElement('input')
  hiddenInput.setAttribute('type', 'hidden')
  hiddenInput.setAttribute('name', 'card_token')
  hiddenInput.setAttribute('value', token.id)
  form.appendChild(hiddenInput)
  form.submit()
}

function tokenErrorHandler(error) {
  new alert().response('error', error.message)
}

export default () => {
  const elements = stripe.elements()

  const card = elements.create('card', {
    classes: {
      empty: 'stripe-element-empty',
      focus: 'stripe-element-focus',
      invalid: 'stripe-element-invalid',
    },
  })
  card.mount('#card')

  const form = document.getElementById('add-card-form')

  form.addEventListener('submit', function(event) {
    event.preventDefault()
    stripe
      .createToken(card, {
        name: document.getElementById('card_holder').value,
        address_line1: document.getElementById('address_line').value,
        address_country: document.getElementById('country').value,
      })
      .then((result) => {
        if (result.token) {
          tokenSuccessHandler(result.token)
        }

        tokenErrorHandler(result.error)
      })
  })
}
